import { MetricCardProps } from '../../../../components/UI-Elements/MetricCard';
import { WideMetricCardProps } from '../../../../components/UI-Elements/WideMetricCard';
import { IBalanceInstruction } from '../../../../sp-types/balanceFlowType';
import { IRoute } from '../../../../sp-types/routeType';
import { formatToShortString } from '../../../../utils/FormatValue';
import { getBalanceTransactionApprovalWideCards } from './getBalanceTransactionApprovalWideCards';

export const getBalanceTransactionApprovalCards = (
  materialName: string,
  quantity: number,
  deliveryDates: string,
  routeDetails: IRoute,
): MetricCardProps[] => {
  const { prices } = routeDetails;
  const { currency, material, shipping, transactionFees } = prices;

  return [
    {
      cards: {
        title: 'Material',
        text: materialName,
        icon: `/assets/icons/gray-bg/material.svg`,
      },
    },
    {
      cards: {
        title: 'Deal type',
        text: 'Monitored',
        units: 'Cash settled',
        icon: `/assets/icons/gray-bg/fullGuarantee-gray.svg`,
      },
    },
    {
      cards: [
        {
          title: 'Quantity',
          text: formatToShortString(quantity, 0),
          units: 'varies',
          icon: `/assets/icons/gray-bg/quantity_gray.svg`,
        },
        {
          title: 'Delivery',
          text: deliveryDates,
          icon: `/assets/icons/gray-bg/dates.svg`,
        },
        {
          title: '`Base material price',
          text: '$' + formatToShortString(material.price, 0),
          units: 'USD',
          icon: `/assets/icons/gray-bg/price.svg`,
        },
      ],
    },
    {
      cards: {
        title: 'Fees',
        text: '$' + formatToShortString(transactionFees.price, 0),
        units: 'USD',
        icon: `/assets/icons/gray-bg/fees.svg`,
      },
    },
    {
      cards: {
        title: 'Total expected price',
        text: '$' + formatToShortString(transactionFees.price + material.price + shipping.price + currency.price, 0),
        units: 'USD',
        icon: '/assets/icons/flat/totalprice.svg',
      },
      style: 'alert',
    },
  ];
};
export const getBalanceWideMetricCardsSplit = (
  materialName: string,
  routeDetails: IRoute,
  balanceInstructions: IBalanceInstruction[],
): { even: WideMetricCardProps[]; odd: WideMetricCardProps[] } => {
  const items = getBalanceTransactionApprovalWideCards(materialName, routeDetails, balanceInstructions);
  return { even: items.filter((_, index) => index % 2 === 0), odd: items.filter((_, index) => index % 2 !== 0) };
};
